import React from 'react';
import { motion } from 'framer-motion';
import { ClosingLine, InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { SnakStill } from '../SnakStill';
import { channelOrbit } from '../../data/snakkerStory';
const RX = 41;
const RY = 40;
function orbitPoint(i: number, count: number) {
  const angle = (-90 + 360 / count * i) * (Math.PI / 180);
  return {
    x: 50 + RX * Math.cos(angle),
    y: 50 + RY * Math.sin(angle)
  };
}
export function SlideChannels({}: SlideProps) {
  return <InteriorSlide data-id="element-344" data-mp="1uc4ri9tosz7">
      <SlideTitle eyebrow="One experience. Many channels." data-id="element-345" data-mp="1tub8tejosuz">
        Bring the interaction to <span className="text-[var(--brand)]" data-id="element-346" data-mp="3t65h5j095s54">where the HCP already is.</span>
      </SlideTitle>

      <div className="relative mt-[clamp(0.75rem,1.5vw,1.25rem)] min-h-0 flex-1" data-id="element-347" data-mp="3o840f4qau4wt">
        <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" data-id="element-348" data-mp="pjonb8r1ide6">
          <ellipse cx="50" cy="50" rx={RX} ry={RY} fill="none" stroke="var(--fg)" strokeOpacity="0.07" strokeDasharray="0.6 0.9" vectorEffect="non-scaling-stroke" data-id="element-349" data-mp="kqls6w6m6vvv" />
          {channelOrbit.map((c, i) => {
          const p = orbitPoint(i, channelOrbit.length);
          return <motion.line key={c} x1="50" y1="50" x2={p.x} y2={p.y} stroke="var(--brand)" strokeOpacity="0.3" strokeWidth="1" vectorEffect="non-scaling-stroke" initial={{
            pathLength: 0
          }} animate={{
            pathLength: 1
          }} transition={{
            delay: 0.35 + i * 0.05,
            duration: 0.6
          }} data-id="element-350" data-mp="3bahk1pxl3ryy" data-mpi={i} />;
        })}
        </svg>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15,
        duration: 0.55
      }} className="absolute left-1/2 top-1/2 flex h-[62%] w-[22%] -translate-x-1/2 -translate-y-1/2 flex-col items-center" data-id="element-351" data-mp="2we06qt5u439r">
          <SnakStill screen={0} alt="The REKOVELLE teaser Snak — built once, activated across channels" className="w-full flex-1" data-id="element-352" data-mp="23h7juzqrawph" />
          <span className="mt-2 flex-shrink-0 rounded-full bg-[var(--fg)] px-3 py-1 text-[clamp(0.55rem,0.72vw,0.68rem)] font-bold uppercase tracking-[0.18em] text-white" data-id="element-353" data-mp="1uica5doi74hf">
            Built once
          </span>
        </motion.div>

        <ul aria-label="Channels" data-id="element-354" data-mp="2m8i6v5td2pc3">
          {channelOrbit.map((c, i) => {
          const p = orbitPoint(i, channelOrbit.length);
          return <motion.li key={c} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.5 + i * 0.06,
            duration: 0.35
          }} className="absolute -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full border border-[var(--fg)]/10 bg-white px-[clamp(0.8rem,1.3vw,1.2rem)] py-[clamp(0.4rem,0.7vw,0.6rem)] text-[clamp(0.72rem,1.05vw,1rem)] font-bold uppercase tracking-[0.12em] text-[var(--fg)] shadow-[0_6px_18px_-10px_rgba(14,27,51,0.25)]" style={{
            left: `${p.x}%`,
            top: `${p.y}%`
          }} data-id="element-355" data-mp="2dh85isc3lowu" data-mpi={i}>
                {c}
              </motion.li>;
        })}
        </ul>
      </div>

      <ClosingLine delay={0.9} data-id="element-356" data-mp="3mj1c734t0915">
        A Snak is channel agnostic. <span className="text-[var(--brand)]" data-id="element-357" data-mp="3rh2v9o28c8cm">Build the interaction once</span> and activate it across the moments that matter.
      </ClosingLine>
    </InteriorSlide>;
}